<!-- @format -->

<template>
	<transition name="modal-fade">
		<div>
			<div class="modal-backdrop">
				<div
					class="modal"
					role="dialog"
					aria-labelledby="modalTitle"
					aria-describedby="modalDescription"
				>
					<slot name="header">
						<!-- <div style="background-color: rgb(76, 92, 122); width: 100%">
							<div class="table-header">Get Customer Number</div>
						</div> -->
						<header
							class="modal-header"
							id="modalTitle"
							style="margin-top: 60px"
						>
							<div>Get Customer Number</div>
						</header>
					</slot>
					<slot name="body">
						<section class="modal-body" id="modalDescription">
							<div class="margin-top-30">
								<add-customer-details />
							</div>

							<div>
								<b-button
									type="button"
									class="is-danger"
									@click="onCloseAddNewCustomerForm"
									aria-label="Close modal"
								>
									X Close
								</b-button>
								<b-button
									type="button"
									style="margin-left: 30px"
									class="is-success"
									:disabled="!!isSaveCustomerDisabled"
									@click="onSaveAddNewCustomerForm"
								>
									Add New Customer
								</b-button>
							</div>
						</section>
					</slot>

					<slot name="footer">
						<footer class="modal-footer"></footer>
					</slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import AddNewCustomerMutation from './AddNewCustomerMutation.graphql'
import useCustomerDetailsForm from './useCustomerDetailsForm.js'
import { onMounted, reactive } from '@vue/composition-api'
import AddCustomerDetails from './AddCustomerDetails.vue'
import { useMutation } from '@vue/apollo-composable'

export default {
	name: 'ModalAddCustomer',
	components: { AddCustomerDetails },
	setup() {
		const {
			schemaCompanies,
			modelCompanies,
			formOptionsCompanies,
			isModalAddCustomerVisible,
			companiesIdentityDetailsReloadKey,
			isSaveCustomerDisabled,
		} = useCustomerDetailsForm()
		// -------------------------------------------------------------------------
		onMounted(() =>
			console.log('isModalAddCustomerVisible', isModalAddCustomerVisible.value),
		)
		// ---------------------------------------------------------------------------
		const onCloseAddNewCustomerForm = () => {
			isModalAddCustomerVisible.value = false
		}
		// ----------------------------------------------------------------------------
		const setVariables = () => {
			return new Promise((resolve, reject) => {
				const condition = true
				if (condition) {
					mutationInput.company_id = modelCompanies.ourCompany
					mutationInput.customer_id = modelCompanies.id
					mutationInput.customer_credit_limit = modelCompanies.creditLimit
					mutationInput.customer_discount_percent = modelCompanies.discount
					mutationInput.customer_email = modelCompanies.email
					mutationInput.customer_invoice_rule =
						modelCompanies.customerInvoiceRule
					mutationInput.customer_is_active = modelCompanies.isActive
					mutationInput.customer_is_risky = modelCompanies.isRisky
					mutationInput.customer_nickname = modelCompanies.nickname
					mutationInput.customer_org_num = modelCompanies.orgNum
					mutationInput.customer_price_class = modelCompanies.customerPriceClass
					mutationInput.customer_reference = modelCompanies.reference
					mutationInput.customer_term = modelCompanies.customerTerm
					mutationInput.customer_title = modelCompanies.title
					mutationInput.send_invoice_by = modelCompanies.sendInvoiceBy
					resolve('ok')
				} else {
					const reason = new Error("Mutation Variables couldn't set")
					reject(reason)
				}
			})
		}
		const mutationInput = reactive({
			company_id: '',
			customer_id: '',
			customer_credit_limit: '',
			customer_discount_percent: '',
			customer_email: '',
			customer_invoice_rule: '',
			customer_is_active: '',
			customer_is_risky: '',
			customer_nickname: '',
			customer_org_num: '',
			customer_price_class: '',
			customer_reference: '',
			customer_term: '',
			customer_title: '',
			send_invoice_by: '',
		})
		const { mutate: AddNewCustomer, onDone } = useMutation(
			AddNewCustomerMutation,
			() => ({
				variables: {
					input: mutationInput,
				},
			}),
		)
		onDone(() => window.alert('Customer is added!'))
		const onSaveAddNewCustomerForm = () => {
			setVariables()
				.then(() => {
					AddNewCustomer()
				})
				.then(() => {
					isModalAddCustomerVisible.value = false
					companiesIdentityDetailsReloadKey.value =
						companiesIdentityDetailsReloadKey.value + 1
					console.log('mutationInput', mutationInput)
				})
		}
		return {
			onCloseAddNewCustomerForm,
			onSaveAddNewCustomerForm,
			isModalAddCustomerVisible,
			isSaveCustomerDisabled,
			// selectedAddress,
			schemaCompanies,
			modelCompanies,
			formOptionsCompanies,
		}
	},
}
</script>

<style scoped>
.modal-backdrop {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.9);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 100000000001;
}

.modal {
	background: #ffffff;
	box-shadow: 2px 2px 20px 1px;
	overflow-x: auto;
	display: flex;
	flex-direction: column;
	max-width: 700px;

	margin: auto;
	padding: 20px;
	opacity: 1;
	overflow-y: auto;
}

.modal-header,
.modal-footer {
	padding: 15px;
	display: flex;
}

.modal-header {
	position: relative;
	color: #4aae9b;
	justify-content: space-between;
}

.modal-footer {
	flex-direction: column;
	justify-content: flex-end;
}

.modal-body {
	position: relative;
	padding: 20px 10px;
}

.modal-fade-enter,
.modal-fade-leave-to {
	opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.5s ease;
}
</style>
